module.exports = __webpack_public_path__ + "static/media/icon-eth.304b83b7.svg";